export default __webpack_public_path__ + "static/media/new-updated-home-banner3.2942981c.jpg";